<template>
    <div class="step-content" v-if="_.size(conditioningSignaturesDocument) > 0">
        <h3 class="hr-title">Customer Signature</h3>

        <div>
            <el-row :gutter="20">
                <el-col v-for="(signature, key) in conditioningSignaturesDocument" :key="key" :span="6" :offset="0">

                    <h3>{{ signature.applicant.full_name }}</h3>
                    <div class="mt-3" v-if="signature.privacyConsentForm && (!_.isEmpty(signature.signature) || !_.isEmpty(signature.previousSignature))">

                        <div v-if="_.get(signature, 'previousSignature.deleted_at', false) && _.isEmpty(signature.signature)" class="mb-3">
                            <span style="color: orange" v-if="_.get(signature, 'previousSignature.deleted_at', false) && _.isEmpty(signature.signature)">Pending Signature</span>
                        </div>
                        <div v-else class="mb-3">
                            <div>
                                <strong>Signed by {{ signature.applicant.full_name }} {{ dateFromNow(signature.privacyConsentForm.created_at) }}</strong>
                            </div>
                            <div>
                                <strong>Signature Date: {{ formatDate(signature.privacyConsentForm.created_at) }}</strong>
                            </div>
                        </div>

                        <h4>Terms and Agreement</h4>

                        <div>
                            <div class="d-flex align-items-center amb-toggle-row-modal mt-2">
                                <div class="amb-table-check-container mr-2">
                                    <input type="checkbox" class="table-checkbox" :checked="_.get(signature, 'privacyConsentForm.status', '') == 'Approved' ? true : false" :disabled="true" />
                                    <span class="amb-table-checkmark"></span>
                                </div>
                                <a href="#" @click="downloadPrivacyConsent(signature.privacyConsentForm)">Privacy Consent Form <span v-if="signature.privacyConsentForm.status" :class="(_.get(signature, 'privacyConsentForm.status', '')).toLowerCase()">({{ signature.privacyConsentForm.status }})</span></a>
                            </div>

                            <div v-if="Ambition.useVwPrivacyStatements()" class="d-flex align-items-center amb-toggle-row-modal mt-2">
                                <div class="amb-table-check-container mr-2">
                                    <input type="checkbox" class="table-checkbox" :checked="_.get(signature, 'vwPrivacyConsentForm.status', '') == 'Approved' ? true : false"  :disabled="true" />
                                    <span class="amb-table-checkmark"></span>
                                </div>
                                <a href="#" @click="downloadVWPrivacyConsent(signature.vwPrivacyConsentForm)">VW Privacy Consent Form <span v-if="signature.vwPrivacyConsentForm.status" :class="(_.get(signature, 'vwPrivacyConsentForm.status', '')).toLowerCase()">({{ signature.vwPrivacyConsentForm.status }})</span></a>
                            </div>

                            <div v-if="Ambition.useMacPrivacyStatements()" class="d-flex align-items-center amb-toggle-row-modal mt-2">
                                <div class="amb-table-check-container mr-2">
                                    <input type="checkbox" class="table-checkbox" :checked="_.get(signature, 'macPrivacyConsentForm.status', '') == 'Approved' ? true : false"  :disabled="true" />
                                    <span class="amb-table-checkmark"></span>
                                </div>
                                <a href="#" @click="downloadMacPrivacyConsent(signature.macPrivacyConsentForm)">Macquarie Privacy Consent Form <span v-if="signature.macPrivacyConsentForm.status" :class="(_.get(signature, 'macPrivacyConsentForm.status', '')).toLowerCase()">({{ signature.macPrivacyConsentForm.status }})</span></a>
                            </div>

                            <div v-if="enableCommercialCreditGuideAndQuote || enableConsumerCreditGuideAndQuote" class="d-flex align-items-center amb-toggle-row-modal mt-2">
                                <div class="amb-table-check-container mr-2">
                                    <input type="checkbox" class="table-checkbox" :checked="_.get(signature, 'creditGuideQuote.status', '') == 'Approved' ? true : false"  :disabled="true" />
                                    <span class="amb-table-checkmark"></span>
                                </div>
                                <a href="#" @click="downloadCreditGuide(signature.creditGuideQuote)">Credit Guide & Quote <span v-if="signature.creditGuideQuote.status" :class="(_.get(signature, 'creditGuideQuote.status', '')).toLowerCase()">({{ signature.creditGuideQuote.status }})</span></a>
                            </div>
                        </div>
                    </div>

                    <div class="mt-3" v-else>
                        <strong>{{signature.applicant.first_name}} has not signed the approval form.</strong>
                    </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>

import { mapGetters } from "vuex"

export default {
    name: 'CustomerSignature',

    data() {
        return {

        };
    },

    computed: {
        ...mapGetters({
            docDocuments: "documents/all",
            fileTypes: "documents/fileTypes",
            conditioningSignaturesDocument: "documents/conditioningSignatures",
            application: "initAppData",
            user: "user/user",
        }),
        isReferrer: function () {
            let roles = this.$store.state.user_roles.roles
            let referrer = roles.find((item) => {
                if (item.name === "referrer") {
                    return item
                }
            })
            return !!referrer
        },
        enableConsumerCreditGuideAndQuote() {
            return Ambition.enableConsumerCreditGuideAndQuote() && this.application.application_type_id == 1
        },
        enableCommercialCreditGuideAndQuote() {
            return Ambition.enableCommercialCreditGuideAndQuote() && this.application.application_type_id == 2
        }
    },

    mounted() {

    },

    methods: {
        dateFromNow(dateTime) {
            return this.$moment.utc(dateTime).tz(this.user.timezone).fromNow()
        },
        formatDate(dateTime) {
            return this.$moment.utc(dateTime).tz(this.user.timezone).format("ddd DD/MM/YY LT")
        },
        downloadPrivacyConsent(consent) {
            let applicantId = _.get(consent, 'uploader_id', _.get(consent, 'applicant.id', false))
            if (applicantId) {
                this.$tenant
                .get(`/api/v2/applications/${this.application.id}/privacy-consent-form/${applicantId}/${consent.id}`)
                .then((res) => {
                    window.open(res.data.path, "_blank")
                })
                .catch((err) => {
                    console.error(err)
                })
            }
        },
        downloadVWPrivacyConsent(consent) {
            let applicantId = _.get(consent, 'uploader_id', _.get(consent, 'applicant.id', false))
            if (applicantId) {
                this.$tenant
                    .get(`/api/v2/applications/${this.$store.getters.appId}/vw-privacy-consent-form/${applicantId}/${consent.id}`)
                    .then((res) => {
                        window.open(res.data.path, "_blank")
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            }
        },
        downloadMacPrivacyConsent(consent) {
            let applicantId = _.get(consent, 'uploader_id', _.get(consent, 'applicant.id', false))
            if (applicantId) {
                this.$tenant
                    .get(`/api/v2/applications/${this.$store.getters.appId}/mac-privacy-consent-form/${applicantId}/${consent.id}`)
                    .then((res) => {
                        window.open(res.data.path, "_blank")
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            }
        },
        downloadCreditGuide(consent) {
            let applicantId = _.get(consent, 'uploader_id', _.get(consent, 'applicant.id', false))
            if (applicantId) {
                this.$tenant
                    .get(`/api/v2/applications/${this.$store.getters.appId}/credit-guide-quote/${applicantId}/${consent.id}`)
                    .then((res) => {
                        window.open(res.data.path, "_blank")
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .rejected {
        color: red
    }
    .pending {
        color: orange
    }
    .approved {
        color: green;
    }
</style>
